import { useParams, useRouter } from '../../../contexts/RouterContext';
import useSlug from '../../hooks/useSlug';

export type Visibility = 'public' | 'private';

/**
 * Manage the visibility tabs for the release group list.
 */
const useVisibility = () => {
  const { visibility } = useParams<{ visibility: string }>();
  const router = useRouter();
  const slug = useSlug();
  const navigateToTab = (tab: Visibility) => {
    router.replace(`/p/${slug}/${tab}`);
  };

  return { visibility, navigateToTab };
};

export default useVisibility;
